module.exports = __webpack_public_path__ + "img/bg_4.fbe012a4.png";